export const SOFTLINE_PERMISSION_UPDATED_ARTICLE_LABEL_PRINT =
  'SOFTAPPS.UPDATED_ARTICLE_LABEL_PRINT';
